/**
 * @desc getRoleAndSubordinateByCode
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(
  params: API.ucenter.userFacadeImpl.getRoleAndSubordinateByCode.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/user/roleAndSubordinateByCode`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
